import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-compra-venta',
  templateUrl: './compra-venta.component.html',
  styleUrls: ['./compra-venta.component.scss']
})
export class CompraVentaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
